import { createPathParamCRUD, type NoPathParams } from "@/api/shared/crud";
import { createService } from "@/api/shared/service";
import type { DefaultPaginatedFilters } from "@/api/shared/filters";
import type { TCompany } from "../company";

export * from "./types";

const SLUG = "practice/company/me";

export interface ICompanyMeFilter extends DefaultPaginatedFilters {}

export default createService(SLUG, {
  ...createPathParamCRUD<TCompany, NoPathParams, ICompanyMeFilter, never, Partial<TCompany>>(SLUG),
});
